
var Model = require("../types/DebouncedModel.js");
var dedupe = require("dedupe");
var par = require("par");

/**
 * Keeps track of the contact list, and the contacts' data
 * @type {Model}
 */
module.exports = Model({
	name: "managedurgencypotentials",
	init: init,
	listeners: listeners,
	debounce: 100, // Debounce pushes by 50 milliseconds

	_contacts: null,
	_managers: null,
	_urgency: null,

	recalculate: recalculate,
});

function init() {
	this._contacts = [];
	this._managers = [];
	this._urgency = [];
	this._managegroup = [];
	this.push([]);
}

function listeners() {
	return {
		"managedurgencycontacts:updated": makeSaveAndRecalc("_urgency"),
		"managedcontacts:updated": makeSaveAndRecalc("_contacts"),
		"managedmanagers:updated": makeSaveAndRecalc("_managers"),
		"managedmanagegroupmanagers:updated": makeSaveAndRecalc("_managegroup")
	};
}

function recalculate() {
	var contacts = this._contacts;
	var managers = this._managers;
	var urgency = this._urgency;
	var managegroup = this._managegroup;

	// Build a list of people that are in the user's contacts or
	// are managing the user, but are not already urgency contacts

	var validManageGroup = managegroup.filter(par(notIn, urgency));
	var validManagers = managers.filter(par(notIn, urgency));
	var validContacts = contacts.filter(par(notIn, urgency));
	var potentials = dedupe(validManagers.concat(validManageGroup).concat(validContacts));

	this.push(potentials);
}

function notIn(list, item) {
	return list.indexOf(item) === -1;
}

function makeSaveAndRecalc(name) {
	return function (data) {
		this[name] = data;
		this.recalculate();
	};
}
